import { render } from "./AddProductGroupItemView.vue?vue&type=template&id=63631d4c"
import script from "./AddProductGroupItemView.vue?vue&type=script&lang=js"
export * from "./AddProductGroupItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__